import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Process } from '../models/process';


@Injectable()
export class ProcessesService {
  baseUrl: string = "";

  constructor(private _http: HttpClient) {
  }

  getProcesses() : Observable<Process[]> {
    return this._http.get<Process[]>('api/processes')
    .pipe(
        catchError(this.handleError<Process[]>('getProcesses', []))
      );
  }

  saveProcess(process) {
    return this._http.post('api/processes', process)
    .pipe(
        catchError(this.handleError<Process>('saveProcess'))
      );
  }

  editProcess(process) {
    return this._http.put('api/processes', process)
    .pipe(
        catchError(this.handleError<Process>('putProcess'))
      );
  }

  /**
 * Handle Http operation that failed.
 * Let the app continue.
 * @param operation - name of the operation that failed
 * @param result - optional value to return as the observable result
 */
private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
